/**
 * Columns exposed by the v_Services_ShrinkReport SQL view.
 * `field` MUST match the column name on the view — the backend whitelists
 * incoming column names against an identical allow-list before building
 * the SELECT clause.
 */
export type ShrinkUptakeField = {
  field: string;
  title: string;
  rawTitle?: string;
  selected?: boolean;
  isDate?: boolean;
  isBoolean?: boolean;
  fromService?: boolean;
};

export const getShrinkUptakeFields = (): ShrinkUptakeField[] => [
  { field: 'CustomerName', title: 'general.customer', selected: true },
  { field: 'NetIdentifier', title: 'net.NetIdentifier', selected: true },
  { field: 'NettingTypeNameList', title: 'netting.NettingType', selected: true },
  { field: 'MainRopeType', title: 'rope.MainRope', selected: true },
  { field: 'TopRopeType', title: 'rope.TopRope', selected: true },
  { field: 'ProductionDate', title: 'net.deliveredDate', selected: true, isDate: true },
  { field: 'ProducerName', title: 'general.producer', selected: true },
  { field: 'Circumference', title: 'netDimension.circumference' , selected: true },
  { field: 'CircumferenceProduction', title: 'netsummary.circumferenceNewNetIncludedExcess', selected: true },
  { field: 'CircumferenceMeasured', title: 'service.circumferenceMeasuredShort', selected: true, fromService: true },
  { field: 'MeasuredDate', title: 'service.measuredDate', selected: true, isDate: true, fromService: true },
  { field: 'MeasurementShrinking', title: 'service.measurementShrinking', selected: true, fromService: true },
  { field: 'TypeNotlin', title: 'general.nettingMaterial' , selected: true },
  { field: 'NetTypeName', title: 'net.type', selected: true },
  { field: 'MeshSize', title: 'notlogg.meshsize' , selected: true },
  { field: 'TypeAntifouling', title: 'service.impregnationType' , selected: true, fromService: true },
  { field: 'ServiceId', title: 'servicestation.serviceid', selected: true, fromService: true },
  { field: 'ServiceDate', title: 'service.serviceDate', selected: true, isDate: true, fromService: true },
  { field: 'ServiceNumber', title: 'reports.service.servicecard.servicenumber', selected: true, fromService: true },
  { field: 'ServiceStation', title: 'general.servicestation', selected: true, fromService: true },
  { field: 'OwnWeight', title: 'service.ownweightBeforeService' , selected: true, fromService: true },
  { field: 'WeightNetAfterDrying', title: 'service.weightNetAfterDrying', selected: true, fromService: true },
  { field: 'ImpregnationLiters', title: 'general.antifouling' , selected: true, fromService: true },
  { field: 'Uptake', title: 'reports.uptake', selected: true, fromService: true },
  { field: 'ImpregnationProductionNrs', title: 'general.productionNumber', selected: true, fromService: true },

  // { field: 'NetId', title: 'net.NetIdentifier'},
  { field: 'ServiceStatus', title: 'notlogg.servicestatus', fromService: true },
  // { field: 'ServiceStationId', title: 'general.servicestation' + '.id' },
  { field: 'NetStatus', title: 'notlogg.netstatus' },
  { field: 'NetIsSpecialProduct', title: 'notlogg.specialproduct', isBoolean: true },
  { field: 'ReceivedDate', title: 'service.receivedDate', isDate: true, fromService: true },
  { field: 'ReceivedFromSiteName', title: 'service.receivedFromSite', fromService: true },
  // { field: 'ReceivedFromSiteId', title: 'service.receivedFromSite' + '.id' },
  // { field: 'ReceivedFromSiteAquacomId', title: 'service.receivedFromSite' + '.aquacomId' },
  { field: 'Year', title: 'general.year', fromService: true },
  { field: 'Streched', title: 'service.measuredStretched', isBoolean: true, fromService: true },
  { field: 'ExcessNettingPercentage', title: 'netdimension.ExcessNettingPercentage' },
  { field: 'ExcessMainRopePercentage', title: 'netdimension.ExcessMainRopePercentage' },
  // { field: 'ImpregnationTypeId', title: 'reports.shrinkUptake.impregnationTypeId' },
  { field: 'AmountWaste', title: 'service.amountWaste', fromService: true },
  { field: 'SumHoursWash', title: 'service.hoursWashed', fromService: true },
  { field: 'SumRepairs1To3Msk', title: 'counter.Repairs1To3Msk', fromService: true },
  { field: 'SumRepairs4To10Msk', title: 'counter.Repairs4To10Msk', fromService: true },
  { field: 'SumRepairsOver10Msk', title: 'service.over10Msk', fromService: true },
  { field: 'BottomBSAvg', title: 'service.measurementBottomBSAvg', fromService: true },
  { field: 'BottomMinBSNewNet', title: 'service.measurementBottomMinBSNewNet', fromService: true },
  { field: 'MiddleSideBSAvg', title: 'service.measurementMiddleSideBSAvg', fromService: true },
  { field: 'MiddleSideMinBSNewNet', title: 'service.measurementMiddleSideMinBSNewNet', fromService: true },
  { field: 'WaterLineBSAvg', title: 'service.measurementWaterLineBSAvg', fromService: true },
  { field: 'WaterLineMinBSNewNet', title: 'service.measurementWaterLineMinBSNewNet', fromService: true },
  { field: 'JumpNetBSAvg', title: 'service.measurementJumpNetBSAvg', fromService: true },
  { field: 'JumpNetMinBSNewNet', title: 'service.measurementJumpNetMinBSNewNet', fromService: true },
];

export const SHRINK_UPTAKE_SELECTED_COLUMNS_KEY = 'service-shrink-uptake-report.selected-columns';
